import Vue from 'vue';

import apiFactory from '@/api/default';
const API = apiFactory('tasks');


const state = {
  tagsSearchResults: [],
  currentTags: {},
};

const getters = {
  tagsSearchResults: (state) => state.tagsSearchResults,
  currentTags: (state) => state.currentTags,
};

const mutations = {
  setTagsSearchResults: (state, tagsSearchResults) => {
    state.tagsSearchResults = tagsSearchResults;
  },
  updateTagsSearchResults: (state, task) => {
    const index = state.tagsSearchResults.findIndex((el)=>el._id === task._id);
    if (index >= 0) Vue.set(state.tagsSearchResults, index, task);
  },
  removeFromTagsSearchResults: (state, id)=>{
    state.tagsSearchResults.data = state.tagsSearchResults.filter((obj)=>{
      return obj._id !== id;
    });
    state.tagsSearchResults.total--;
  },
  setCurrentTags: (state, currentTags) => {
    state.currentTags = currentTags;
  },
};

const actions = {
  async searchTasks({commit}, query) {
    const response = await API.search(query);
    commit('setTagsSearchResults', response.data);
    return response.data;
  },
  async loadTask({commit}, id) {
    const response = await API.load(id);

    commit('setCurrentTags', response.data);
    return response.data;
  },
  async createTask({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
  async updateTask({commit}, payload) {
    const response = await API.update(payload.id, payload.data);
    commit('updateTagsSearchResults', response.data);
    return response.data;
  },
  async deleteTask({commit}, id) {
    const response = await API.remove(id);
    commit('removeFromTagsSearchResults', id);
    return response;
  },
  async renderImages({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
  async startTraining({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
